module.exports = __webpack_public_path__ + "static/media/nba-sprites.3f7b6eab.png";